import { ANSWERS } from "./words";
import { DailyLevel } from "./engine";

const DAY_MS = 24 * 60 * 60 * 1000;
const EPOCH = Date.UTC(2026, 0, 1);

export const DAILY_LEVELS: Record<DailyLevel, { label: string; tries: number; wordLength: number; description: string; answers: string[] }> = {
  easy: {
    label: "Easy",
    tries: 7,
    wordLength: 5,
    description: "More guesses, friendlier words",
    answers: ["PLANT", "SHARE", "LIGHT", "STONE", "CLOUD", "RIVER", "HONEY", "MANGO", "SOLAR", "SPARK"]
  },
  classic: {
    label: "Classic",
    tries: 6,
    wordLength: 5,
    description: "The familiar daily puzzle",
    answers: ANSWERS
  },
  expert: {
    label: "Expert",
    tries: 5,
    wordLength: 6,
    description: "Six letters, fewer guesses",
    answers: ["ABSORB", "BEACON", "CIPHER", "VOYAGE", "GALAXY", "JUNGLE", "MATRIX", "NEBULA", "ORCHID", "PYTHON", "QUARTZ", "RHYTHM", "SPHINX", "VECTOR", "ZEPHYR"]
  }
};

export const DAILY_LEVEL_ORDER: DailyLevel[] = ["easy", "classic", "expert"];

export function getLocalPuzzleDate(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getPuzzleNumber(dateKey: string) {
  const [year, month, day] = dateKey.split("-").map(Number);
  return Math.max(1, Math.floor((Date.UTC(year, month - 1, day) - EPOCH) / DAY_MS) + 1);
}

function fnv1a(input: string) {
  let hash = 0x811c9dc5;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export function getDailyAnswer(dateKey = getLocalPuzzleDate(), level: DailyLevel = "classic") {
  const offset = new Date().getTimezoneOffset();
  const levelConfig = DAILY_LEVELS[level] ?? DAILY_LEVELS.classic;
  const seed = fnv1a(`${dateKey}:${offset}:${level}:lexi-link-mvp`);
  return levelConfig.answers[seed % levelConfig.answers.length];
}

export function getNextReset(now = new Date()) {
  const reset = new Date(now);
  reset.setHours(24, 0, 0, 0);
  return reset;
}
